module.exports = __webpack_public_path__ + "static/media/fa-regular-400.fc9c63c8.eot";